import React, { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import { Button } from "primereact/button";
import Loader from "../../../../../Base/Components/Loader/Loader";
import { OverlayPanel } from "primereact/overlaypanel";
import AgGrid from "../../../../../Base/Components/Tables/AgGrid/AgGrid";
import {
  FacturaByConceptoRetencion,
  FacturasProveedor,
} from "../../../../../API/Suministros/IngresosBodega/IngresosBodegaEncabezadoRequest";
import { toastShow } from "../../../../../Base/Services/ToastService";
import { Toast } from "primereact/toast";

const OverlayFacturaProveedor = ({
  IdVendor,
  habilitar,
  AsignarInformacion,
  IdConceptoRetencion = 0,
}) => {
  const { userAuth } = useContext(AuthContext);
  const fp = useRef(null);
  const toast = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const getInfo = async () => {
    setIsOpen(true);
    setLoading(true);
    // if (IdVendor > 0 && IdConceptoRetencion === 0) {
    //   const facturasProveedor = await FacturasProveedor(IdVendor);
    //   setData(facturasProveedor);
    // }
    if (IdVendor > 0 && IdConceptoRetencion > 0) {
      const tempoRetenciones = await FacturaByConceptoRetencion(
        IdVendor,
        IdConceptoRetencion
      );
      setData(tempoRetenciones);
    }
    setLoading(false);
  };

  const columns = [
    {
      field: "IdIngreso",
      header: "Id",
      headerEn: "Id",
      className: "small",
      width: 60,
      hidden: userAuth.IdRol === 1,
    },
    {
      field: "NumeroIngreso",
      header: "No Ingreso",
      headerEn: "No Ingreso",
      className: "Xsmall",
      Format: "Center",
      Sumary: "count",
      onCellClicked: (e) => {
        AsignarInformacion([e?.data], fp, e);
        setIsOpen(false);
      },
    },
    {
      field: "CustomerName",
      header: "Proveedor",
      headerEn: "Supplier",
      className: "",
      onCellClicked: (e) => {
        AsignarInformacion([e?.data], fp, e);
        setIsOpen(false);
      },
    },

    {
      field: "Factura",
      header: "Factura",
      headerEn: "Bill",
      className: "",
    },
    {
      field: "FechaFactura",
      header: "Fecha Factura",
      headerEn: "Bill Date",
      className: "medium",
      Format: "Date",
    },
    {
      field: "FechaIngreso",
      header: "Fecha Ingreso",
      headerEn: "Entry Date",
      className: "medium",
      Format: "Date",
    },
    {
      field: "MontoL",
      header: "Monto L",
      headerEn: "Amount L",
      className: "Xsmall",
      Format: "Currency",
      Sumary: "sum",
      Frozen: true,
      alignFrozen: "right",
    },
    {
      field: "MontoD",
      header: "Monto $",
      headerEn: "Amount $ ",
      className: "Xsmall",
      Format: "Currency",
      Sumary: "sum",
      Frozen: true,
      alignFrozen: "right",
    },
  ];

  const table = {
    Columns: columns,
    Data: data,
    // showModal: () => {},
  };

  const openOver = (e) => {
    if (IdConceptoRetencion === 0) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Debe seleccionar un concepto de retención"
      );
      return;
    }
    if (!IdVendor) {
      toastShow(toast, "warn", "Advertencia", "Debe seleccionar un proveedor");
      return;
    }

    fp?.current.toggle(e);
    getInfo();
  };

  useEffect(() => {
    getInfo();
  }, [IdVendor, IdConceptoRetencion]);

  return (
    <div>
      <Toast ref={toast} />
      <Button icon="pi pi-plus" disabled={!habilitar} onClick={(e) => openOver(e)} />
      <Loader loading={loading} querySelector={"#FacturasProveedor"} />
      <OverlayPanel
        dismissable={false}
        ref={fp}
        style={{ width: "50vw", height: "45vh" }}
        onHide={() => setIsOpen(false)}
        showCloseIcon
      >
        <div style={{ height: "38vh" }} id="FacturasProveedor">
          <AgGrid table={table} />
        </div>
      </OverlayPanel>
    </div>
  );
};

export default OverlayFacturaProveedor;
